/*
 * @Description: 表单管理
 * @Date: 2024-12-23 09:59:27
 */
import { route } from './src/router';

const name = 'form-manage';
export { name, route };
